import { render, staticRenderFns } from "./scheduled-imports-index.vue?vue&type=template&id=5876d27e&scoped=true&"
import script from "./scheduled-imports-index.vue?vue&type=script&lang=js&"
export * from "./scheduled-imports-index.vue?vue&type=script&lang=js&"
import style0 from "./scheduled-imports-index.vue?vue&type=style&index=0&id=5876d27e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876d27e",
  null
  
)

export default component.exports